import { Box, Button, Collapse, IconButton, TableCell, TableRow } from "@material-ui/core";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import { makeStyles } from "@material-ui/styles";
import React from "react";
import { useIntl } from "react-intl";
import { SwissGermanLocale } from "../../../../data/constants";
import { ModuleForSignupViewModel } from "../../../../model/ExamSignup/ExamSessionForSignupViewModel";
import { ModuleSelectionViewModel } from "../../../../model/ExamSignup/ModuleSelectionViewModel";
import { GetTranslatedValueIntl, TranslatedValue } from "../../../../model/Shared/TranslatedValue";
import TranslatedMessage from "../../../translations/TranslatedMessage";
import ModuleExamList from "./ModuleExamList";

export type UserSelectionRowProps = {
  examSessionId: string;
  examSessionKey: TranslatedValue;
  courseId: string;
  courseName: TranslatedValue;
  module: ModuleForSignupViewModel;
  rowButtonAction: (module: ModuleSelectionViewModel) => void;
  disabled: boolean;
};

const useStyles = makeStyles({
  button: { textTransform: "none", whiteSpace: "nowrap" },
  noPadding: { paddingBottom: 0, paddingTop: 0 },
});

export const UserSelectionRow: React.FunctionComponent<UserSelectionRowProps> = ({
  examSessionId,
  examSessionKey,
  courseId,
  courseName,
  module,
  rowButtonAction,
  disabled,
}) => {
  const [open, setOpen] = React.useState(false);
  const intl = useIntl();

  const classes = useStyles();

  return (
    <React.Fragment>
      <TableRow>
        <TableCell>
          <IconButton size="small" onClick={() => setOpen(!open)} color="primary">
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell style={{ fontWeight: "bold" }}>{GetTranslatedValueIntl(intl, module.name)}</TableCell>
        <TableCell>{GetTranslatedValueIntl(intl, courseName)}</TableCell>
        <TableCell>{GetTranslatedValueIntl(intl, examSessionKey)}</TableCell>
        <TableCell align="right">
          {module.price.toLocaleString(SwissGermanLocale, { minimumFractionDigits: 2 })}
        </TableCell>
        <TableCell>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              rowButtonAction({
                courseId,
                examSessionId,
                moduleId: module.id,
                price: module.price,
              });
            }}
            className={classes.button}
            disabled={disabled}
          >
            <TranslatedMessage id="startCertification.moduleSelectionStep.removeButton" />
          </Button>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell className={classes.noPadding} />
        <TableCell className={classes.noPadding} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box margin={open ? 1 : 0}>
              <ModuleExamList exams={module.exams} />
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
};
